<template>
  <div>
    <v-progress-circular
      v-if="isLoading"
      :size="70"
      :width="7"
      color="primary"
      indeterminate
      class="centered loading"
    ></v-progress-circular>
    <div class="report-crm" :class="{ 'blur--content': isLoading }">
      <h1 class="text-center">Customer Metrics</h1>
      <FilterMetric
        :is-submit="isSubmit"
        :error="error"
        :is-show-ok-button="true"
        @filterMetrics="getRetentionProcessId"
      />
      <JobTable
        metric-type="CUSTOMER_METRICS"
        @getRequestParams="getCustomerReportJobList"
        :list-job-data="listCustomerJobData"
        :total-rows="totalRows"
      />
    </div>
    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog">
        <h5 class="p-3">{{ message }}</h5>
        <div class="text-center">
          <button class="btn-back" @click="showDialog = false">ปิด</button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import ReportService from "services/api/report.service";
import FilterMetric from "@/views/Reports/MetricsUtils/FilterMetric.vue";
import JobTable from "@/views/Reports/MetricsUtils/JobTable.vue";
import moment from "moment";

export default {
  components: {
    JobTable,
    FilterMetric,
  },
  data() {
    return {
      processId: null,
      listCustomerJobData: [],
      isLoading: false,
      isSubmit: false,
      message: null,
      showDialog: false,
      totalRows: null,
      error: {
        errorBrand: null,
        errorDate: null,
        errorSources: null,
        errorChannel: null,
      },
      jobRequestParams: {
        currentPage: null,
        limit: null,
        sortColumn: null,
        sortType: null,
        key: null,
        brandCode: null,
        type: null,
      },
    };
  },
  methods: {
    async getRetentionProcessId(form) {
      this.isSubmit = true;
      this.message = null;
      this.resetErrorText();
      this.isLoading = true;
      const selectedSourcesKey = form.selectedSources?.map((s) => s.key);
      const param = {
        brand: form.brandSelected?.id,
        date: form.dateSelect,
        isIncludeVVIP: form.isIncludeVVIP,
        channel: form.selectedChannel?.key,
        sources: selectedSourcesKey.join(","),
      };
      await ReportService.getRetentionMetricsProcessId(param)
        .then((res) => {
          const data = res.data;
          this.processId = data.processId;
          this.getCustomerReportJobData();
        })
        .catch((err) => {
          this.isLoading = false;
          console.log("Error: ", err);
          const errRes = err.response;
          const errorData = errRes?.data;
          if (errorData.errors?.length > 0) {
            this.setErrorText(errorData.errors);
          }
          if (errRes.status !== 400) {
            this.isLoading = false;
            this.message =
              errRes.data?.message ||
              "An error occurred, please try again later!";
            this.showDialog = true;
          }
        });
    },
    getCustomerReportJobList(params) {
      this.isLoading = true;
      this.jobRequestParams = {
        currentPage: params.currentPage,
        limit: params.limit,
        sortColumn: params.sortColumn,
        sortType: params.sortType,
        key: params.key,
        brandCode: params.brandCode,
        type: params.type,
      };
      this.getCustomerReportJobData();
    },
    getCustomerReportJobData() {
      ReportService.getReportJobs(this.jobRequestParams)
        .then((res) => {
          const data = res.data;
          this.listCustomerJobData = data.reportJobs.map((c) => {
            let formattedCustomerFilter = "";
            let requestCustomerFilterObj = JSON.parse(c.request);
            Object.entries(requestCustomerFilterObj).forEach(([key, value]) => {
              formattedCustomerFilter += key + ": " + value + "\n";
            });
            return {
              ...c,
              status: this.leadWithUpperCase(c.status),
              dateCreated: moment(c.dateCreated).format("YYYY-MM-DD HH:mm:ss"),
              request: formattedCustomerFilter,
            };
          });
          this.totalRows = data.totalItems;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log("Error: ", err);
          this.isLoading = false;
        });
    },
    setErrorText(errors) {
      this.error.errorBrand = errors.find((e) => e.fieldName === "brand");
      this.error.errorDate = errors.find((e) => e.fieldName === "date");
      this.error.errorSources = errors.find((e) => e.fieldName === "sources");
      this.error.errorChannel = errors.find((e) => e.fieldName === "channel");
    },
    resetErrorText() {
      this.error = {
        errorBrand: null,
        errorDate: null,
        errorSources: null,
        errorChannel: null,
      };
    },
    leadWithUpperCase(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped>
label[required]::after {
  content: "*";
  color: red;
  margin-left: 5px;
}

.blur--content {
  filter: blur(2px);
  pointer-events: none;
}

.loading {
  z-index: 10;
}

.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 20px;
}

.content-dialog {
  height: 200px;
  background: #fff;
  padding: 10px;
  overflow-x: hidden;

  h5 {
    text-align: center;
    padding: 3rem 0 2rem;
  }

  .btn-back {
    border: 1px solid #1976d2;
    width: 28%;
    height: 39px;
    border-radius: 25px;
    color: #1976d2;
  }

  .btn-back:hover {
    text-decoration: underline;
  }
}
</style>
